module.exports = __webpack_public_path__ + "35d6162b11f28467f852d11226ea59fa.svg";